/**
 * Review modal: rate a completed booking (stars + comment).
 */
import React from 'react';

export default function ReviewModal({
  show,
  reviewTarget,
  lang,
  t,
  stars,
  setStars,
  comment,
  setComment,
  onSubmit,
  onClose,
}) {
  if (!show || !reviewTarget) return null;
  return (
    <div
      className="review-backdrop"
      role="dialog"
      aria-modal="true"
      aria-labelledby="review-modal-title"
    >
      <div
        className={`review-modal glass fade-in ${lang === 'ar' ? 'review-modal-rtl' : ''}`}
        dir={lang === 'ar' ? 'rtl' : 'ltr'}
      >
        <h3 id="review-modal-title">
          {t('reviewTitle')} <em>{reviewTarget.shopName}</em>
        </h3>

        <div className="stars">
          {[1, 2, 3, 4, 5].map((n) => (
            <button
              key={n}
              className={n <= stars ? 'on' : ''}
              aria-label={`${n} ${lang === 'ar' ? 'نجمة' : 'star'}`}
              onClick={() => setStars(n)}
            >
              ★
            </button>
          ))}
        </div>

        <textarea
          rows="4"
          placeholder={t('reviewPlaceholder')}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          dir={lang === 'ar' ? 'rtl' : 'ltr'}
        />

        <div className="btn-row">
          <button
            className="btn primary"
            disabled={stars === 0}
            onClick={onSubmit}
          >
            {t('reviewSubmit')}
          </button>
          <button className="btn danger outline" onClick={onClose}>
            {t('reviewLater')}
          </button>
        </div>
      </div>
    </div>
  );
}
